export const commentSeeds = [
  { user: "瓜田里的守望者", content: "看完立刻转到了家族群，我妈回了我三个「哈哈」。", time: "2 小时前", likes: 1284 },
  { user: "今天也在摸鱼", content: "建议直接做成表情包，我已经在工位上笑出声了。", time: "3 小时前", likes: 976 },
  { user: "爱吃瓜的柚子", content: "这个梗我家楼下小卖部老板娘都在用，传播速度惊人。", time: "4 小时前", likes: 812 },
  { user: "周一不想上班", content: "太真实了，真实到我想举报。", time: "5 小时前", likes: 1543 },
  { user: "半糖不加冰", content: "作者是把我的日常偷拍下来了吗？", time: "6 小时前", likes: 702 },
  { user: "评论区的课代表", content: "课代表总结：能笑出来的都是懂生活的。", time: "6 小时前", likes: 631 },
  { user: "深夜冲浪选手", content: "凌晨刷到，笑完更精神了，谢谢。", time: "8 小时前", likes: 588 },
  { user: "小陈同学", content: "已经存图，准备明天群里第一个发。", time: "9 小时前", likes: 476 },
  { user: "隔壁老王头", content: "年轻人玩梗的速度，我跟不上了。", time: "10 小时前", likes: 402 },
  { user: "一杯美式续命", content: "通勤路上看这个，差点坐过站。", time: "12 小时前", likes: 389 },
  { user: "吃饭第一名", content: "这条评论区比内容还好笑，我两个都看了三遍。", time: "13 小时前", likes: 358 },
  { user: "追瓜不追星", content: "蹲一个后续，蹲到了记得叫我。", time: "15 小时前", likes: 342 },
  { user: "梦游的鱼", content: "笑点很密，但笑完之后居然有点共情。", time: "16 小时前", likes: 315 },
  { user: "打工人小张", content: "这就是我的早八状态，一模一样。", time: "18 小时前", likes: 297 },
  { user: "沙发上的橘子", content: "把这个设成手机壁纸，效率立刻提升（并没有）。", time: "19 小时前", likes: 264 },
  { user: "会飞的鲸鱼", content: "已经分享给三个朋友，他们都沉默了，然后笑了。", time: "20 小时前", likes: 243 },
  { user: "不吃香菜本人", content: "看到评论区的香菜梗，我笑到打鸣。", time: "21 小时前", likes: 228 },
  { user: "楼下便利店常客", content: "收藏夹又满了，快乐也满了。", time: "22 小时前", likes: 205 },
  { user: "爱睡懒觉的猫", content: "看完只想说：你们都太会了。", time: "23 小时前", likes: 188 },
  { user: "记忆面包", content: "这个可以拿去开会活跃气氛，亲测有效。", time: "1 天前", likes: 176 },
  { user: "风里的小旗子", content: "求同款表情包，评论区有没有链接。", time: "1 天前", likes: 152 },
  { user: "顶楼的信号", content: "笑点属于那种越品越有味道的类型。", time: "1 天前", likes: 138 },
  { user: "橘子汽水", content: "转发给同事，我们隔着屏幕一起笑了。", time: "1 天前", likes: 121 },
  { user: "慢半拍的阿远", content: "我反应比较慢，看到最后才懂，但懂了之后真的好笑。", time: "1 天前", likes: 96 },
];